<template>
<div >
    <p class="title">选择项目</p>
    <div>
        <p>1、首先在项目列表页查看所有项目，选中项目后，进入项目详情查看项目公告信息，然后点击前往招标采购页进行投标。</p>
        <img src="../assets/help/1.1.1-1.png" alt="">
        <img src="../assets/help/1.1.1-2.png" alt="">
    </div>
</div>
</template>
<script>
export default {
    name:'center',
    data(){
        return{
            
        }

    }
}
</script>
<style>

</style>